var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_273_1456)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.425537 5.70213L7.23405 0.425537L14.0426 5.70213V14.0426C14.0426 14.8936 13.3617 15.5745 12.5106 15.5745H1.95745C1.10639 15.5745 0.425537 14.8936 0.425537 14.0426V5.70213V5.70213Z",
    stroke: "#223A84",
    strokeMiterlimit: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.93617 15.5745V8H9.53192V15.5745",
    stroke: "#223A84",
    strokeMiterlimit: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_273_1456"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.4681,
    height: 16,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.9e745767d0778ec67cea888e0d5635d1.svg";
export { ForwardRef as ReactComponent };